/**
 * Contenedor principal del dashboard, alineado con Panel (inicio), Diario y Presupuesto.
 */
export const DASHBOARD_PAGE_CONTAINER = "mx-auto max-w-7xl p-6 lg:p-10";
